import { useEffect, useState } from "react";
import api, { formatApiError } from "../../lib/api";
import { toast } from "sonner";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Switch } from "../ui/switch";
import { Plus, Trash } from "@phosphor-icons/react";

export default function PhrasesTab() {
  const [phrases, setPhrases] = useState([]);
  const [form, setForm] = useState({ phrase: "", weight: 5, category: "umum" });

  const load = () => api.get("/admin/phrases").then((r) => setPhrases(r.data)).catch((e) => toast.error(formatApiError(e)));
  useEffect(() => { load(); }, []);

  const create = async () => {
    try {
      await api.post("/admin/phrases", { ...form, weight: Number(form.weight) });
      toast.success("Frasa ditambahkan ke dictionary");
      setForm({ phrase: "", weight: 5, category: "umum" });
      load();
    } catch (e) { toast.error(formatApiError(e)); }
  };

  const update = async (id, updates) => {
    try { await api.put(`/admin/phrases/${id}`, updates); load(); }
    catch (e) { toast.error(formatApiError(e)); }
  };

  const remove = async (id) => {
    try { await api.delete(`/admin/phrases/${id}`); toast.success("Frasa dihapus"); load(); }
    catch (e) { toast.error(formatApiError(e)); }
  };

  return (
    <div className="space-y-4 max-w-3xl">
      <div className="bg-card border border-border p-4 flex flex-wrap items-end gap-3">
        <div className="flex-1 min-w-48 space-y-1">
          <p className="text-xs text-muted-foreground">Frasa mencurigakan (bahasa Indonesia)</p>
          <Input data-testid="phrase-input" value={form.phrase} onChange={(e) => setForm((s) => ({ ...s, phrase: e.target.value }))} placeholder="contoh: baru pindah alamat" />
        </div>
        <div className="w-24 space-y-1">
          <p className="text-xs text-muted-foreground">Bobot</p>
          <Input data-testid="phrase-weight-input" type="number" min="1" max="20" value={form.weight} onChange={(e) => setForm((s) => ({ ...s, weight: e.target.value }))} />
        </div>
        <div className="w-36 space-y-1">
          <p className="text-xs text-muted-foreground">Kategori</p>
          <Input data-testid="phrase-category-input" value={form.category} onChange={(e) => setForm((s) => ({ ...s, category: e.target.value }))} />
        </div>
        <Button data-testid="add-phrase-button" onClick={create} disabled={!form.phrase.trim()}
          className="bg-slate-900 hover:bg-slate-800 rounded-none gap-2"><Plus size={16} /> Tambah</Button>
      </div>

      <div className="bg-card border border-border">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-xs uppercase tracking-wider text-muted-foreground border-b border-border">
              <th className="px-4 py-3 font-medium">Frasa</th>
              <th className="px-3 py-3 font-medium">Kategori</th>
              <th className="px-3 py-3 font-medium w-20">Bobot</th>
              <th className="px-3 py-3 font-medium w-20">Aktif</th>
              <th className="px-3 py-3 w-12"></th>
            </tr>
          </thead>
          <tbody>
            {phrases.map((p) => (
              <tr key={p.id} data-testid={`phrase-row-${p.id}`} className="border-b border-border/60 last:border-0">
                <td className="px-4 py-2.5 font-medium">"{p.phrase}"</td>
                <td className="px-3 py-2.5 text-xs text-muted-foreground">{p.category}</td>
                <td className="px-3 py-2.5 font-mono">+{p.weight}</td>
                <td className="px-3 py-2.5">
                  <Switch data-testid={`phrase-active-${p.id}`} checked={p.active} onCheckedChange={(v) => update(p.id, { active: v })} />
                </td>
                <td className="px-3 py-2.5">
                  <button data-testid={`phrase-delete-${p.id}`} onClick={() => remove(p.id)} className="text-muted-foreground hover:text-red-600 transition-colors duration-150"><Trash size={16} /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="text-xs text-muted-foreground">Total kontribusi frasa dibatasi maksimal +20 poin per klaim.</p>
    </div>
  );
}
